import type { ComponentProps } from 'react';
import { FindBar } from '../find/FindBar.js';

/** U228: filtering only reads. It remains usable while viewing as someone. */
export function FilterBar(props: ComponentProps<typeof FindBar>) { return <FindBar {...props} />; }
export { matchesWords, tally } from '../find/FindBar.js';
export type { BarPick } from '../find/FindBar.js';
